import { Enum_LiveStream_Provider } from '@core/api';
import { isLiveStream, isLiveStreamLive, isLiveStreamReplay, } from '@core/livestream/helpers';
import { isSafari } from '@core/userAgent';
import { EnumVideoWrapperType } from './types';
/**
 * Whether the video is suitable for AgoraWrapper.
 */
export function shouldUseAgoraWrapper(video) {
    return Boolean(isLiveStream(video) &&
        video.live_stream_provider === Enum_LiveStream_Provider.AGORA &&
        (isLiveStreamLive(video) || video.clientExtension?.isStreaming));
}
/**
 * Whether to use IVS wrapper for the video.
 *
 * Please note: All `m3u8` videos (including Agora replays)
 * will be played using IVS hence the reason why we don't verify provider.
 */
export function shouldUseIvsWrapper(video, __di = { isSafari }) {
    return (isLiveStream(video) &&
        // Safari supports hls video natively so we don't want to
        // use IVS - but only for replay for now.
        ((isLiveStreamReplay(video) && !__di.isSafari) || isLiveStreamLive(video)));
}
/**
 * Test if wrapper is AgoraWrapper.
 */
export function isAgora(wrapper) {
    return wrapper.type === EnumVideoWrapperType.AGORA;
}
/**
 * Test if wrapper is IVSWrapper.
 */
export function isIVS(wrapper) {
    return wrapper.type === EnumVideoWrapperType.IVS;
}
/**
 * Test if wrapper is simple VideoWrapper.
 */
export function isVideo(wrapper) {
    return wrapper.type === EnumVideoWrapperType.VIDEO;
}
/**
 * Test if wrapper is any of the video wrappers.
 */
export function isVideoWrapper(wrapper) {
    return typeof wrapper === 'object' && wrapper !== null && 'type' in wrapper;
}
